import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';

export function isUsuarioSupervisor(authData) {
  if (!authData) return false;
  return authData.supervisor === true || authData.supervisor === 'true';
}

/**
 * Quem pode acessar /v2/relatorio-inspecao e exportar relatório de inspeção em NSIRs.
 * Requer flag `supervisor` no usuário (auth/login e cadastro).
 */
export function canViewInspecaoReport({ authData, userRole }) {
  if (!authData?.email) return false;
  const role = userRole ?? authData.role;
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(role)) return false;
  return isUsuarioSupervisor(authData);
}
